import React,{useState} from 'react';
import '../styles/Cuerpo.css';
import apid from '../components/EmailJS';
import * as FaIcons from 'react-icons/fa';
import {init,send as emailsend} from '@emailjs/browser';
import logofondo from '../imagenes/fondoleo.svg';
init(apid.KEY);

const Cuerpo = () => {

    const [from_name, cfrom_name] = useState('');
    const [telefono, ctelefono] = useState('');
    const [interes, cinteres] = useState('');
    const [message, cmessage] = useState('');
    const [thanks, showThanks] = useState(false);

    const onChange = (d) => {
        if (d.target.validity.valid || d.target.value === "") {
            if (d.target.name ==='from_name'){
                cfrom_name(d.target.value)
            } else if(d.target.name === 'telefono'){
                ctelefono(d.target.value)
            } else if(d.target.name === 'interes'){
                cinteres(d.target.value)
            } else if(d.target.name === 'message'){
                cmessage(d.target.value)
            }}
    }

    const onSubmit = (e) => {
        e.preventDefault();

        const parametros = {
            from_name: e.target.from_name.value,
            telefono: e.target.telefono.value,
            interes: e.target.interes.value,
            message: e.target.message.value
        };
       
        if (validar(parametros)){
            // console.log(e.target.interes)
            emailsend(apid.SERVICE,apid.TEMPLATE, parametros)
                .then(function(response) {
                // console.log('SUCCESS!', response.status, response.text);

                // alert('Muchas gracias, hemos recibido su correo y nos comunicaremos a la brevedad con usted '+parametros.from_name);
                }, function(error) {
                console.log('FAILED...', error);
                });
            cfrom_name('');
            ctelefono('');
            cinteres('');
            cmessage('');
            moMensaje();
            // console.log('si enviamos')
        } else {
            console.log('No se envió correo')
        }
    }

    const moMensaje = () => {
        showThanks(true);

        setTimeout(() => {
            showThanks(false)
         }, 3000);
    }

    const validar = (p) =>{
            if (p.from_name==='' ){
                alert('No puede dejar vacío el nombre')
                return false
            } else if (p.telefono==='' || p.telefono.length<10){
                alert('Debe capturar un teléfono válido')
                return false
            } else if (p.message===''){
                alert('Por favor indíquenos en un breve mensaje lo que desea, esto para facilitar su proceso')
                return false
            }
            return true
    }

    return (
        // style={{ backgroundImage: `url(${logofondo})` }} esta imagen va en el primer div para ponerla de fondo
        <div className='CuerpoPrincipal' style={{ backgroundImage: `url(${logofondo})` }}>
            <div className='ubicacion'>
            <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3359.9181654456056!2d-115.45025678444746!3d32.635002681015166!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d771a555376691%3A0x17a2059de2a35581!2sLeonardo%20Larios%20Hair%20Studio!5e0!3m2!1sen!2smx!4v1647895191375!5m2!1sen!2smx" 
                allowFullScreen={false} 
                loading="lazy"
                className='mapaleo'
                title='Llegar al salon'></iframe>
            </div>
            <form action="submit" onSubmit={onSubmit} className="formulario">
            <div className='tituloform'>
                <h2>Contáctanos</h2>
            </div>
            <div className='eleform'>
                <label htmlFor="from_name" className="label">Nombre:</label>
                <div className="inputgroup">
                    <FaIcons.FaRegLaugh className="icon"/>
                    <input 
                        type="text"
                        name="from_name" 
                        id="from_name"
                        className="input"
                        value={from_name}
                        onChange={onChange}
                        required
                    />
                   
                </div>
            </div>
            <div  className='eleform'>
                <label htmlFor="telefono" className="label">Teléfono:</label>
                <div className="inputgroup">
                    <FaIcons.FaMobileAlt className="icon" />
                    <input  
                        type="tel" 
                        name="telefono"
                        id="telefono"
                        minLength="0"
                        maxLength="10"
                        className="input"
                        pattern="[0-9]{0,10}"
                        placeholder='6862901579'
                        value={telefono}
                        onChange={onChange}
                        required
                    />
                </div>
            </div>
            <div className="eleform">
                <label className='label'>Interesad@ en:</label>
                <div className='inputgroup'>
                    <FaIcons.FaSearch className="icon" />
                    <select 
                        id='interes' 
                        className='input' 
                        name='interes'
                        value={interes}
                        onChange={onChange}
                    >
                        <option key='1' value='Compra de Producto'>Productos</option> 
                        <option key='2' value='Cita para Servicio de Cabello'>Cita</option>
                        <option key='3' value='Duda'>Duda</option>
                    </select>
                </div>
            </div>
            <div  className='eleform'>
                <label htmlFor="message" className="label">Mensaje:</label>
                <div className="inputgroup">
                    <FaIcons.FaKeyboard className="icon" />
                    <textarea  
                        type="textarea" 
                        name="message"
                        id="message"
                        className="inputmessage"
                        value={message}
                        onChange={onChange}
                        placeholder='Por favor describa brevemente su duda o servicio a solicitar.'
                        required
                        rows='8'></textarea>
                </div>
            </div>
            <div className='eleform'>
                <button type="submit"  className="button">Enviar Mensaje</button>
            </div>
            {thanks && (
                <div>
                    <h3>Gracias por contactarnos, nos pondremos en contacto.</h3>
                </div>
            )}         
          </form>

        </div>

    );
}
 
export default Cuerpo;